import { useContext, useEffect, useState } from 'react';

import TextSurveyAnswerApi from '../../../api/textSurveyAnswerApi';
import { TextSurveyContentData } from '../../../types/contentTypes';
import { AuthContext } from '../../../utils/AuthProvider';
import TextArea from '../../atoms/text-area/TextArea';

interface TextSurveyContentProps {
  content: TextSurveyContentData;
  onComplete: (() => void) | undefined;
}

export default function TextSurveyContent({ content, onComplete }: TextSurveyContentProps) {
  const [answer, setAnswer] = useState<string>();
  const { user } = useContext(AuthContext)!;
  const [timerId, setTimerId] = useState<NodeJS.Timeout>();

  useEffect(() => {
    async function fetchData() {
      if (!user) return;
      const surveyAnswer = await TextSurveyAnswerApi.getUserAnswerForContent(content.id, user.uid);
      if (surveyAnswer) {
        setAnswer(surveyAnswer.answer);
      }
    }

    fetchData();
  }, [content.id, user]);

  useEffect(() => {
    function handleChange() {
      if (!user || answer === undefined) return;
      clearTimeout(timerId);
      const newTimerId = setTimeout(async () => {
        await TextSurveyAnswerApi.addOrUpdateSurveyAnswer({
          surveyContentId: content.id,
          userId: user.uid,
          answer,
        });
        onComplete?.();
      }, 3000);
      setTimerId(newTimerId);
    }
    handleChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want a change in answer to trigger the effect
  }, [answer]);

  return (
    <section>
      <h2 className="strong-heading mb-8">{content.headline}</h2>
      <p className="mb-8">{content.description}</p>
      <form className="flex flex-col sm:w-[600px] gap-8 mx-auto">
        <div>
          <TextArea state={[answer, setAnswer]} className="w-full" rows={5} placeholder="Write your answer here" />
        </div>
      </form>
    </section>
  );
}
